import { render } from "./StockAutocompleteComponent.vue?vue&type=template&id=bfc7e43c&scoped=true&ts=true"
import script from "./StockAutocompleteComponent.vue?vue&type=script&lang=ts"
export * from "./StockAutocompleteComponent.vue?vue&type=script&lang=ts"

import "./StockAutocompleteComponent.vue?vue&type=style&index=0&id=bfc7e43c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfc7e43c"]])

export default __exports__